export default "/fonts/vendor/balm-ui/material-icons-round.woff2?14fc6f6a609772c817b079935a592f55";